import deepDiff from 'deep-diff';

// src/helpers/reports/reducer.ts
var reportHasChanges = (changeData) => {
  const _diff = deepDiff(changeData.originalData, changeData.data);
  return Boolean(_diff && _diff.length > 0);
};

export { reportHasChanges };
